<script>
export default {
  name: "LoginCarousel",
  data: () => ({
    cycle: true,
    model: 0,
    items: [{ src: require("@/assets/login-bg.webp") }]
  }),
  methods: {
    toggleCycle() {
      this.cycle = !this.cycle;
    }
  },
  computed: {
    hasMultipleItems() {
      return this.items.length > 1;
    }
  }
};
</script>
<template>
  <div class="carousel-wrapper">
    <v-card class="login-carousel">
      <v-carousel
        v-if="hasMultipleItems"
        hide-delimiters
        height="100%"
        :cycle="cycle"
        v-model="model"
      >
        <template v-slot:prev="{ on, attrs }">
          <v-btn fab x-small color="white" v-bind="attrs" v-on="on">
            <v-icon color="primary" size="24">mdi-arrow-left</v-icon>
          </v-btn>
        </template>
        <template v-slot:next="{ on, attrs }">
          <v-btn fab x-small color="white" v-bind="attrs" v-on="on">
            <v-icon color="primary" size="24">mdi-arrow-right</v-icon>
          </v-btn>
        </template>
        <v-carousel-item v-for="(item, i) in items" :key="i"
          ><v-img :src="item.src" height="100%" cover />
        </v-carousel-item>
      </v-carousel>
      <v-img
        v-else-if="items.length === 1"
        :src="items[0].src"
        height="100%"
        cover
        class="login-carousel__image"
      />
    </v-card>
    <ul class="custom-delimiters" v-if="hasMultipleItems">
      <li
        v-for="(item, index) in items"
        :key="index"
        :class="{ active: model === index }"
        @click="model = index"
      >
        <v-icon>mdi-circle</v-icon>
      </li>
      <li>
        <v-btn fab x-small color="white" @click="toggleCycle()">
          <v-icon color="primary" size="24">
            {{ cycle ? "mdi-pause" : "mdi-play" }}
          </v-icon>
        </v-btn>
      </li>
    </ul>
  </div>
</template>
<style scoped>
.carousel-wrapper {
  position: relative;
}
.login-carousel .v-carousel {
  flex: 1;
  min-height: 0;
}

.login-carousel {
  width: 100%;
  display: flex;
  flex-direction: column;
}

@media (min-width: 960px) {
  .login-carousel {
    aspect-ratio: 3 / 4;
    border-radius: 8px 0 0 8px !important;
  }
}

@media (max-width: 959px) {
  .carousel-wrapper {
    width: 100%;
    height: auto;
    aspect-ratio: 3 / 2;
  }
  .login-carousel {
    width: 100%;
    height: 100%;
    border-radius: 0 !important;
  }
}

.custom-delimiters {
  position: absolute;
  bottom: -10px;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 12px;
  list-style: none;
  z-index: 2;
  cursor: pointer;
}
.custom-delimiters li .v-icon {
  color: white;
  font-size: 10px;
}
.custom-delimiters li.active .v-icon {
  color: #b40055;
  font-size: 15px;
}
</style>
